import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { AuthService } from 'src/app/admihair/service/auth.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { VerificarUsuarioService } from '../../service/verificar-usuario.service';
import { VerificarUsuario } from '../../api/dto/verificar-usuario';
import { UsuarioService } from '../../service/usuario.service';
import { Usuario } from '../../api/dto/usuario';
import { ErroService } from '../../service/erro.service';
import { HttpStatusCode } from '@angular/common/http';

@Component({
	templateUrl: './confirmar-conta.component.html'
})
export class ConfirmarContaComponent {
	
	messages: Message[] = [{ severity: '', summary: '', detail: '' }]; 
	messagemVisivel: boolean = false;
	temErro: boolean = false;

	id?: string;
	aceite?: boolean;
	carregando: boolean = false;
	sucesso?: boolean = false;
	verificarUsuario?: VerificarUsuario;

	constructor(private verificarUsuarioService: VerificarUsuarioService,
		private erroService: ErroService,
		private usuarioService: UsuarioService,
		private layoutService: LayoutService,
		private authService: AuthService,
		private utilStorageService: UtilStorageService,
		private _router: Router,
		private activatedRoute: ActivatedRoute) { }

	get dark(): boolean {
		return this.layoutService.config.colorScheme !== 'dark';
	}

	ngOnInit(): void {
		this.carregarIdGrupo();
	}

	buscarVerificarUsuario(){
		this.verificarUsuarioService.buscarPorId(this.id).subscribe({
			next: (data: VerificarUsuario) => {
				this.verificarUsuario = data;
				if(this.verificarUsuario && this.verificarUsuario.usuario ){
					if(this.verificarUsuario.ativo){
						const usuario: Usuario = {
							id: this.verificarUsuario.usuario.id,
							situacaoConfirmacaoConta: this.aceite ? 'CONFIRMADO' : 'REJEITADO'
						}
						this.atualizarConta(usuario);
						this.carregando = true;
					} else {
						this.messages = [{ severity: 'warn', summary: 'Atenção', detail: 'E-mail já confirmado' }];
						this.messagemVisivel = true;
						this.carregando = true;
					}
					
				}
				

			},
			error: (err: any) => {
				if(err.status == HttpStatusCode.NotFound){
					this.messages = [{ severity: 'error', summary: 'Erro', detail: 'Informação não encontrada' }];
					this.messagemVisivel = true;
					this.temErro = true;
					this.carregando = true;
				} else {
					this.temErro = true;
					this.messages = this.erroService.handleErro(err);
					this.messagemVisivel = true;
					this.carregando = false;
				}
				
			}
		});
	}

	atualizarConta(usuario?: Usuario){
		console.log(usuario)
		this.usuarioService.atualizarConta(usuario).subscribe({
			next: ()=> {

			},
			error: (err: any) => {
				this.temErro = true;
				this.messages = this.erroService.handleErro(err);
        		this.messagemVisivel = true;
			}
		});

	}

	carregarIdGrupo() {
		const idParam = this.activatedRoute.snapshot.paramMap.get('id');
		const aceiteParam = this.activatedRoute.snapshot.paramMap.get('aceito');
		if (idParam && aceiteParam) {
			this.id = idParam;
			this.aceite = aceiteParam == "true" ? true : false;
			this.buscarVerificarUsuario();
		}


		console.log(this.id, this.aceite)


	}


	redirecionarSelecionarEmpresa() {
		this._router.navigate(["/selecionar-empresa"], { relativeTo: this.activatedRoute })
	}

}
